export default __webpack_public_path__ + "img/Montserrat-ExtraBold_75ee419.woff";